import { useNavigate } from "react-router-dom";

interface Props {
  code: string;
  message: string;
  onRetry?: () => void;
}

const FRIENDLY_MESSAGES: Record<string, string> = {
  missing_address: "Please enter an address.",
  invalid_asking_price: "Please enter a valid asking price.",
  invalid_address_format:
    "Include city and state in the address, e.g. '24 Crisp St, Savannah, GA'.",
  address_not_found:
    "We couldn't find that address in the property database. Check spelling, then try again.",
  http_error: "The server returned an error. Please try again shortly.",
  configuration_error:
    "PriceTilt is misconfigured for this environment. Contact support.",
};

export function ErrorState({ code, message, onRetry }: Props) {
  const navigate = useNavigate();
  const friendly = FRIENDLY_MESSAGES[code] || message;

  if (code === "subscription_ended") {
    return (
      <div className="error-state subscription-ended" role="alert">
        <h2>Your Pro subscription has ended</h2>
        <p>
          Resubscribe anytime to pick up where you left off with unlimited
          verified reports and AI analysis.
        </p>
        <button
          type="button"
          className="resubscribe-btn"
          onClick={() => navigate("/upgrade")}
        >
          Resubscribe to Pro
        </button>
      </div>
    );
  }

  return (
    <div className="error-state" role="alert">
      <h2>Something went wrong</h2>
      <p>{friendly}</p>
      <p className="error-code">Error code: {code}</p>
      {onRetry && (
        <button type="button" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
